import { elementController } from '@public-pages/runtime-core';

import { useTracking } from '@services/tracking';

elementController('banner', ({ query }) => {
  const { elementClickedEvent } = useTracking();
  const button = query('.button') as HTMLButtonElement;
  button.addEventListener('click', handleClick);

  function handleClick(this: HTMLButtonElement) {
    elementClickedEvent({
      elementType: 'button',
      location: window.location.pathname,
      position: 'banner',
      text: this.textContent!,
    });
  }
});
